import React from 'react';
import { Form, Input, Button, Alert, Spin } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { logIn } from '../../redux/reducers/authSlice';
import loginLogo from '../../assets/images/login-logo.png';
import './LoginScreen.css';

// const { Text } = Typography;

interface LoginFormData {
  email: string;
  password: string;
}

const LoginScreen: React.FC = () => {
  const dispatch = useAppDispatch();
  const { fetching, error } = useAppSelector((state) => state.auth);
  const [form] = Form.useForm();

  const handleSubmit = async (values: LoginFormData) => {
    try {
      await dispatch(logIn(values)).unwrap();
    } catch (err) {
      // Error is handled in the Redux slice
    }
  };

  const handleForgotPassword = () => {
    // Open forgot password URL - matching mobile app behavior
    window.open('https://dev.shzoom.com/account/forgotpassword', '_blank');
  };

  return (
    <div className="login-container">
      <div className="login-header-container">
        <img 
          src={loginLogo} 
          alt="UPtime by SHzoom" 
          className="login-logo" 
        />
      </div>

      <div className="login-form-container">
        <Form
          form={form}
          name="login"
          onFinish={handleSubmit}
          layout="vertical"
          size="large"
          autoComplete="off"
        >
          <Form.Item
            name="email"
            rules={[
              { required: true, message: 'Please enter your email' },
              { type: 'email', message: 'Please enter a valid email' },
            ]}
          >
            <Input
              prefix={<UserOutlined />}
              placeholder="Email"
              type="email"
              autoComplete="email"
            />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[
              { required: true, message: 'Please enter your password' },
            ]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="Password"
              autoComplete="current-password"
            />
          </Form.Item>

          {error && (
            <Form.Item>
              <Alert
                message="Login Failed"
                description={error.message || 'Invalid email or password'}
                type="error"
                showIcon
              />
            </Form.Item>
          )}

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              loading={fetching}
              block
              size="large"
            >
              Log In
            </Button>
          </Form.Item>

          <div style={{ textAlign: 'center', marginTop: '16px' }}>
            <Button type="link" onClick={handleForgotPassword}>
              Forgot password?
            </Button>
          </div>
        </Form>
      </div>

      {fetching && (
        <div className="login-loading">
          <Spin size="large" />
        </div>
      )}
    </div>
  );
};

export default LoginScreen;